// extracted by mini-css-extract-plugin
module.exports = {"link":"PixLink_link__2rtGm"};